export default "__VITE_ASSET__CjYg5oJv__"